import React from 'react';

import './styles.scss';

const LandingPageCTABanner = ({
  text,
  buttons = [],
  subText,
  countDownTimer,
  secondaryComponent,
}) => {
  return (
    <div className="landing-page-cta-banner">
      <div className="cta-text">
        {text}
        {countDownTimer && countDownTimer}
        {subText && <span className="sub-text">{subText}</span>}
      </div>
      <div className="cta-container">
        <div className="cta-button">{!!buttons.length && buttons}</div>
        {secondaryComponent}
      </div>
    </div>
  );
};

export default LandingPageCTABanner;
